import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import { SnackBarModule } from "../../../modules/SnackBarModule";
import { ProcessamentoService } from "../../../services/ProcessamentoService";
export default {
    name: "ImportarDotacoes",
    components: {
        Breadcrumb
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Dotações',
                disabled: false
            },
            {
                text: 'Importar Dotações',
                disabled: true
            }
        ],
        arquivo: null,
        loading: false,
        uploadProgress: null,
        blockInputFile: false,
        scheduledList: [],
        isDragOver: false
    }),
    created() {
        this.loadScheduledList();
    },
    methods: {
        async loadScheduledList() {
            const scheduledList = await ProcessamentoService.scheduled('dotacao');
            this.scheduledList = scheduledList && scheduledList.data ? scheduledList.data : [];
        },
        async refreshPage() {
            this.loadScheduledList();
            await SnackBarModule('Lista de Processos Atualizada', 'info');
        },
        async retryProcessamento(item) {
            try {
                const formData = new FormData();
                formData.append('id', item.id);

                const response = await ProcessamentoService.retry(formData);
                if (response) {
                    this.loadScheduledList();
                } 
            } catch (error) {
                console.error('Erro ao tentar reprocessar o item:', error);
            }
        },
        uploadFile() {
            if (!this.arquivo) {
                console.error('Nenhum arquivo selecionado.');
                return;
            }

            this.blockInputFile = true;
            const formData = new FormData();
            formData.append('arquivo', this.arquivo);
            formData.append('type', 'dotacao');

            ProcessamentoService.store(formData)
                .then(response => {

                    if (response.error) {
                        this.blockInputFile = false;
                        this.uploadProgress = null;
                        this.arquivo = null;
                        SnackBarModule('Ocorreu um erro devido ao documento ser incompatível com a entidade', 'error');
                        return;
                    }

                    let progress = 0;
                    this.blockInputFile = true;
                    this.arquivo = null;
                    const interval = setInterval(() => {
                        progress += Math.random() * 10;
                        if (progress >= 100) {
                            clearInterval(interval);
                            this.uploadProgress = null;
                            this.loadScheduledList();
                        } else {
                            this.uploadProgress = progress;
                        }
                    }, 500);
                })
                .catch(error => {
                    console.error('Erro ao enviar o arquivo:', error);
                    this.uploadProgress = null;
                    this.blockInputFile = false;
                    this.arquivo = null;
                    SnackBarModule('Ocorreu um erro devido ao documento ser incompatível com a entidade', 'error');
                });
                this.blockInputFile = false;
        },
        getStatusClass(item) {
            if (!item.processado) {
                return 'awaiting-process';
            } else if (item.erro) {
                return 'processing-error';
            } else {
                return 'processing-success';
            }
        },
        getStatusText(item) {
            if (!item.processado) {
                return 'Aguardando Processamento';
            } else if (item.erro) {
                return 'Erro de Processamento';
            } else {
                return 'Processamento concluído';
            }
        },
        getStatusIcon(item) {
            if (!item.processado) {
                return 'mdi-clock-outline';
            } else if (item.erro) {
                return 'mdi-alert-circle-outline';
            } else {
                return 'mdi-checkbox-marked-circle-outline';
            }
        },
        // Métodos para drag & drop
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        handleFileSelect(event) {
            const file = event.target.files[0];
            if (file) {
                this.processFile(file);
            }
        },
        handleFileDrop(event) {
            this.isDragOver = false;
            const file = event.dataTransfer.files[0];
            if (file) {
                this.processFile(file);
            }
        },
        processFile(file) {
            // Verificar se é um arquivo Excel
            const allowedTypes = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                'application/vnd.ms-excel' // .xls
            ];
            
            if (!allowedTypes.includes(file.type)) {
                SnackBarModule('Por favor, selecione um arquivo Excel (.xlsx ou .xls)', 'error');
                return;
            }
            
            this.arquivo = file;
            this.uploadFile();
        },
        // Métodos para cores e estilos
        getStatusColor(item) {
            if (!item.processado) {
                return 'warning';
            } else if (item.erro) {
                return 'error';
            } else {
                return 'success';
            }
        },
        getStatusChipColor(item) {
            if (!item.processado) {
                return 'warning';
            } else if (item.erro) {
                return 'error';
            } else {
                return 'success';
            }
        },
        getStatusTextColor() {
            return 'white';
        },

        getErrorSummary(erro) {
            if (!erro) return '';

            const totalMatch = erro.match(/Total de registros com erro: (\d+)/);
            if (totalMatch) {
                return `${totalMatch[1]} registro(s) com erro - Clique para ver detalhes`;
            }

            return 'Erro no processamento - Clique para ver detalhes';
        },

        parseErrors(erro) {
            if (!erro) return [];

            const erros = [];
            const linhas = erro.split('\n');
            let erroAtual = null;

            for (let i = 0; i < linhas.length; i++) {
                const linha = linhas[i].trim();

                if (!linha || linha.startsWith('Total de registros')) {
                    continue;
                }

                const erroMatch = linha.match(/--- Erro #(\d+) \(Linha (\d+|N\/A)\) ---/);
                if (erroMatch) {
                    if (erroAtual) {
                        erros.push(erroAtual);
                    }

                    const linhaNumero = erroMatch[2] === 'N/A' ? 0 : parseInt(erroMatch[2]);

                    erroAtual = {
                        numero: parseInt(erroMatch[1]),
                        linha: linhaNumero,
                        motivo: '',
                        dados: {}
                    };
                    continue;
                }

                if (linha.startsWith('Motivo:')) {
                    if (erroAtual) {
                        erroAtual.motivo = linha.replace('Motivo:', '').trim();
                    }
                    continue;
                }

                if (linha.startsWith('Dados:')) {
                    if (erroAtual) {
                        const dadosStr = linha.replace('Dados:', '').trim();

                        // Caso 1: JSON (como em dotacoes)
                        if (dadosStr.startsWith('{')) {
                            try {
                                const obj = JSON.parse(dadosStr);
                                erroAtual.dados = obj || {};
                            } catch (e) {
                                erroAtual.dados = { bruto: dadosStr };
                            }
                        } else {
                            // Caso 2: formato chave=valor, separado por vírgulas (como em outros imports)
                            const dadosPairs = dadosStr.split(',').map(pair => pair.trim());
                            dadosPairs.forEach(pair => {
                                const equalIndex = pair.indexOf('=');
                                if (equalIndex > 0) {
                                    const key = pair.substring(0, equalIndex).trim();
                                    const value = pair.substring(equalIndex + 1).trim();
                                    if (key && value) {
                                        erroAtual.dados[key] = value;
                                    }
                                }
                            });
                        }
                    }
                    continue;
                }
            }

            if (erroAtual) {
                erros.push(erroAtual);
            }

            if (erros.length === 0 && erro.trim()) {
                return [{
                    numero: 1,
                    linha: 0,
                    motivo: erro.length > 200 ? erro.substring(0, 200) + '...' : erro,
                    dados: {}
                }];
            }

            return erros;
        },

        formatFieldName(key) {
            const fieldNames = {
                '0': 'Ano Exercício',
                '1': 'Unidade Executora',
                '2': 'Código Dotação',
                '3': 'Código Completo',
                '4': 'Valor',
                '5': 'Grupo',
                '6': 'Unidade Orçamentária',
                '7': 'Função',
                '8': 'Subfunção',
                '9': 'Programa',
                '10': 'Ação',
                '11': 'Elemento',
                '12': 'Elemento Item',
                '13': 'IPG',
                '14': 'Elemento Extra',
                '15': 'Fonte',
                '16': 'IPU',
                '17': 'Índice Final',
                'bruto': 'Dados brutos'
            };
            return fieldNames[key] || key;
        }
    }
};